/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { isEmpty } from 'lodash';

const __vue_script__ = {
    name: 'FileDropper',

    props: {
        /**
         * If provided a check against content.SUPPORTED_MIME_TYPES will be performed
         * in order to determine what is possible to upload.
         */
        acceptedMimes: {
            type: Array,
            default: () => []
        },

        /**
         * Use this instead of `acceptedMimes` if you already performed a check of supported
         * mimes outside the scope of this component.
         */
        supportedMimes: {
            type: Array,
            default: () => []
        },

        maxSize: {
            type: Number,
            default: Math.pow(8, 8)
        },

        multiple: {
            type: Boolean,
            default: true
        }
    },

    data() {
        let mimes, types, allTypes;
        if (!isEmpty(this.supportedMimes)) {
            mimes = this.supportedMimes;
            allTypes = this.$utils.assets.humanReadableMime(mimes);
        } else {
            const SUPPORTED_MIME_TYPES = this.$services.content.SUPPORTED_MIME_TYPES;
            mimes = Object.keys(SUPPORTED_MIME_TYPES).filter(m => this.acceptedMimes?.includes(m));

            allTypes = this.acceptedMimes.map(m => {
                const mime = SUPPORTED_MIME_TYPES[m];
                if (mime) {
                    return mime.toLocaleUpperCase();
                } else {
                    const allMimes = Object.keys(mimes).join(', ');
                    console.error(`[FileDropper] Unsupported mime type: ${m}. Mime must be one of ${allMimes}`);
                }
            });

        }

        types = this.$utils.strings.humanJoin(allTypes || [], this.$i18n.t('base.and'));
        return {
            types,
            mimes,
            humanSize: this.$utils.numbers.humanFileSize(this.maxSize),
            over: false
        };
    },

    computed: {
        /** @returns {string} */
        accept() {
            return this.mimes.length ? this.mimes.join(', ') : null;
        },

        /** @returns {string} */
        cssClasses() {
            return this.over ? 'active' : '';
        }
    },

    methods: {
        /** @param {DragEvent} event */
        onDrop(event) {
            this.changed(event.dataTransfer.files);
        },

        onDragOver() {
            this.over = true;
        },

        selectFiles() {
            // @ts-ignore
            this.$refs.input.click();
        },

        /** @param {FileList} files */
        changed(files) {
            const dt = new DataTransfer();

            for (const file of Array.from(files)) {
                if (this.isFileValid(file)) {
                    dt.items.add(file);
                }
            }

            files = dt.files;

            if (files.length) {
                this.$emit('input', files);
            } else {
                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('general.forms.no_valid_files').toString(),
                    type: 'error'
                });
            }
        },

        clear() {
            this.$refs.input.value = '';
        },

        /**
         * Checks the file validity
         *
         * @param {File} file the file to check
         *
         * @returns {boolean} true if the file is valid
         */
        isFileValid(file) {
            const { type, size } = file;
            if (size > this.maxSize) {
                console.error('[FileDropper] File size is too big', { size, maxSize: this.maxSize });
                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('media.uploads.file_too_big', this.maxSize).toString(),
                    type: 'error'
                });
                return false;
            }

            // If the user drag&drops the files
            // we have to filter accepted them manually
            if (this.accept && !this.mimes?.includes(type)) {
                console.error('[FileDropper] File type is not accepted', { type, accepted: this.mimes });
                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('media.uploads.file_type_not_accepted').toString(),
                    type: 'error'
                });
                return false;
            }

            return true;
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-dropper"},[_c('div',{staticClass:"allowed-factors"},[(_vm.types.length)?[_vm._v(_vm._s(_vm.$tc('media.uploads.constraints_type', _vm.types.length, [_vm.types]))+"\n")]:_vm._e(),[_vm._v(_vm._s(_vm.$t('media.uploads.constraints_size', [_vm.humanSize])))]],2),_c('div',{staticClass:"drop-zone",class:_vm.cssClasses,on:{"drop":function($event){$event.preventDefault();return _vm.onDrop($event)},"dragover":function($event){$event.preventDefault();return _vm.onDragOver($event)},"dragleave":function($event){_vm.over = false},"dragenter":function($event){$event.preventDefault();}}},[_c('i',{staticClass:"ic-upload"}),_c('i18n',{attrs:{"path":"general.forms.drag_and_drop","tag":"p"}},[_c('a',{staticClass:"has-action",on:{"click":_vm.selectFiles}},[_vm._v(_vm._s(_vm.$t('general.forms.drag_and_drop_action')))])]),_c('input',{ref:"input",attrs:{"type":"file","multiple":_vm.multiple,"accept":_vm.accept},on:{"change":function($event){return _vm.changed($event.target.files)}}})],1)])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "FileDropper.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__